/**
 * Created by Jan Bradac on 4.1.2016.
 */

// TODO MOBA II - refactor to an JSNSOB
FullDomPathProvider = {
    /**
     * TODO MOBA II - cannot be used in context where this warning (↓↓) is an issue...
     * - Existing usages of this method should be replaced by calls to IdsGenerator
     * Warning: does not guarantee that the selector returned is unique!
     * And probably can never do so because of given examples:
     * - Two elements with the same ID.
     * - Two siblings with exactly the same attributes.
     * -- (we cannot encode the order (nth child of ...), because of dynamically added/removed DOM elements)
     * - Update: Consider modifying this to be primarily or even exclusively used in debugging.
     * 
     * TODO MOBA II - consider replacing by https://github.com/fczbkk/css-selector-generator
     *
     *
     * Source: http://stackoverflow.com/questions/5728558/get-the-dom-path-of-the-clicked-a
     * @param {jQuery} $element
     * @param {boolean=false} includeDataAttributes Whether data attibutes should be part of the path. Beware of
     *                        elements which may have their path stored in their data attribute!
     * @returns {string}
     */
    getFullDomPath: function ($element, includeDataAttributes) {
        if (typeof includeDataAttributes === 'undefined') {
            includeDataAttributes = false;
        }

        if($element.is(document) || $element.is(":root")) {
            return FullDomPathProvider.getElementDescriptor($element[0], includeDataAttributes)
        }

        var parentPaths = [];

        $element.parents().addBack().not('html').each(function(){
            parentPaths.push(FullDomPathProvider.getElementDescriptor(this, includeDataAttributes));
        });

        return parentPaths.join(" ");
    },

    getSanitizedDomPath: function ($element) {
        return this.getFullDomPath($element).replace(/[\s.#]/g, "--");
    },

    /**
     * Provides all data attributes of given element.
     * Source: http://stackoverflow.com/a/5915585/5500468 .
     * @param {HTMLElement} element
     * @param {boolean=false}toCamelCase
     */
    getDataOfElement: function (element, toCamelCase) {
        var data = {};
        [].forEach.call(element.attributes, function (attr) {
            if (/^data-/.test(attr.name)) {
                var name = attr.name.substr(5);

                if (toCamelCase === true) {
                    name = name.replace(/-(.)/g, function ($0, $1) {
                        return $1.toUpperCase();
                    });
                }

                data[name] = attr.value;
            }
        });

        return data;
    },

    getElementDescriptor: function (element, includeDataAttributes) {
        if (typeof includeDataAttributes === 'undefined') {
            includeDataAttributes = false;
        }

        var path;
        if(element.tagName !== undefined) {
            path = element.tagName.toLowerCase();
        } else {
            if (typeof element.nodeName === 'undefined') {
                throw new Error ("Unable to determine the element's tag name.");
            }
            // Note: this can not be used as a CSS selector (since there is no selector for such an element) and is
            // therefore only useful for debugging.
            path = element.nodeName.replace('#', '');
        }

        if (element.id) {
            path += "#" + element.id;
        } else {
            if (element.className) {
                path += "." + element.className.trim().replace(/\s+/g, '.');
            }

            // We do not include data attributes by default, only when explicitly asked to do so.
            // a. They might cause recursive explosion if the path returned from this function was stored in data
            //    attribute.
            // b. This method was inspired by Chrome's path provider, which does not use data.
            if (includeDataAttributes === true) {
                // Data attributes
                var data = FullDomPathProvider.getDataOfElement(element);

                _.each(data, function (value, key) {
                    path += "[" + "data-" + key + "=" + value + "]";
                });
            }
        }

        return path;
    },

    /**
     * Calculate a string representation of a node's DOM path.
     *
     * An alternative way of defining the path.
     *
     * Example output: `body>div:eq(1)>div>section:eq(1)>div:eq(1)>div>div>div:eq(1)>form>div:eq(3)>div`
     * TODO Later - should be used to improve our own methods.
     * Source: https://stackoverflow.com/a/42284488/5500468
     */
    getAlternativePathToElement: function (node) {
        if (!node || !node.outerHTML) {
            return null;
        }

        var path;
        while (node.parentElement) {
            var name = node.localName;
            if (!name) break;
            name = name.toLowerCase();
            var parent = node.parentElement;

            var domSiblings = [];

            if (parent.children && parent.children.length > 0) {
                for (var i = 0; i < parent.children.length; i++) {
                    var sibling = parent.children[i];
                    if (sibling.localName && sibling.localName.toLowerCase) {
                        if (sibling.localName.toLowerCase() === name) {
                            domSiblings.push(sibling);
                        }
                    }
                }
            }

            if (domSiblings.length > 1) {
                name += ':eq(' + domSiblings.indexOf(node) + ')';
            }
            path = name + (path ? '>' + path : '');
            node = parent;
        }

        return path;
    }
};
